import { render, staticRenderFns } from "./manageConfig.vue?vue&type=template&id=82da3a24&"
import script from "./manageConfig.vue?vue&type=script&lang=js&"
export * from "./manageConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports